var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTripReportS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20.5714286px",
    viewBox: "0 0 16 20.5714286",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/trip-report-S ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KLM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/trip-report-S-",
    fill: "#B3D6E5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20.5714286 L16,20.5714286 L16,0 L0,0 L0,20.5714286 Z M2.28571429,16 L10.2857143,16 L10.2857143,14.8571429 L2.28571429,14.8571429 L2.28571429,16 Z M2.28571429,12.5714286 L13.7142857,12.5714286 L13.7142857,11.4285714 L2.28571429,11.4285714 L2.28571429,12.5714286 Z M2.28571429,9.14285714 L13.7142857,9.14285714 L13.7142857,8 L2.28571429,8 L2.28571429,9.14285714 Z M7.976,2.92571429 L4.21828571,6.29714286 L1.71657143,4.06857143 L2.85485714,2.78857143 L4.21371429,4 L6.83085714,1.65714286 C7.21257143,2.08 7.59428571,2.50285714 7.976,2.92571429 Z M8,5.71428571 L13.7142857,5.71428571 L13.7142857,4.57142857 L8,4.57142857 L8,5.71428571 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripReportS);
export default __webpack_public_path__ + "static/media/trip-report-S.33050e3ce19eab4da6b878ad632cb529.svg";
export { ForwardRef as ReactComponent };